export default {
  payments: {
    title: 'Платежи',
    history: 'История платежей',
    create: 'Оплатить',
    amount: 'Сумма',
    provider: 'Способ оплаты',
    status: 'Статус',
    date: 'Дата',
    description: 'Описание',
    noPayments: 'Нет платежей',
    statuses: {
      created: 'Создан',
      pending: 'В обработке',
      waiting_for_capture: 'Ожидает подтверждения',
      succeeded: 'Оплачен',
      failed: 'Ошибка',
      canceled: 'Отменён',
      refunded: 'Возвращён',
    },
    providers: {
      yookassa: 'Банковская карта',
      stripe: 'Stripe',
      wallet: 'Кошелёк',
    },
    popup: {
      title: 'Оплата',
      selectProvider: 'Выберите способ оплаты',
      confirm: 'Подтвердить оплату',
      processing: 'Обработка платежа...',
      success: 'Оплата прошла успешно',
      failed: 'Ошибка оплаты',
      cancel: 'Отмена',
    },
    refund: {
      title: 'Возврат',
      amount: 'Сумма возврата',
      reason: 'Причина',
      confirm: 'Вернуть средства',
    },
  },
  subscriptions: {
    title: 'Подписки',
    active: 'Активная',
    subscribe: 'Подписаться',
    cancel: 'Отменить подписку',
    pause: 'Приостановить',
    resume: 'Возобновить',
    noSubscriptions: 'Нет активных подписок',
    nextBilling: 'Следующее списание',
    cancelAtEnd: 'Отменится в конце периода',
    statuses: {
      trial: 'Пробный период',
      active: 'Активна',
      past_due: 'Просрочена',
      paused: 'Приостановлена',
      canceled: 'Отменена',
    },
  },
  plans: {
    title: 'Тарифы',
    selectPlan: 'Выбрать тариф',
    perMonth: '/мес',
    perYear: '/год',
    perWeek: '/нед',
    perDay: '/день',
    trial: 'Бесплатно {days} дней',
    features: 'Возможности',
  },
  paymentMethods: {
    title: 'Способы оплаты',
    empty: 'Нет сохранённых карт. Карта сохранится после первой оплаты подписки.',
    default: 'По умолчанию',
    makeDefault: 'Сделать основной',
    remove: 'Отвязать',
    confirmRemove: 'Отвязать карту? Автоматическое продление подписки будет остановлено.',
    cardMasked: '•••• {last4}',
    expires: 'до {month}/{year}',
    types: {
      bank_card: 'Банковская карта',
      yoo_money: 'ЮMoney',
      sberbank: 'СберБанк',
      sbp: 'СБП',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      mir_pay: 'Mir Pay',
      tpay: 'T-Pay',
    },
  },
};
